import flatpickr from 'flatpickr'

export default {
  mounted() {
    let cal = flatpickr(this.el, {
      mode: this.el.dataset.mode || 'single',
      enableTime: false,
      altInput: this.el.dataset.altinput === 'false' ? false : true,
      // Tuesday, June 4, 2024
      // l, F j, Y
      altFormat: this.el.dataset.altformat || 'n/j/Y',
      onReady: (selectedDates, dateStr, instance) => {
        // Prevent clicks on the calendar from closing the modal
        const calendar = instance.calendarContainer;
        calendar.addEventListener('click', (e) => {
          e.stopPropagation();
        });
        
        // Also prevent clicks on the month/year selectors
        const monthSelect = calendar.querySelector('.flatpickr-monthDropdown-months');
        const yearInput = calendar.querySelector('.numInput.cur-year');
        if (monthSelect) monthSelect.addEventListener('click', (e) => e.stopPropagation());
        if (yearInput) yearInput.addEventListener('click', (e) => e.stopPropagation());
      },
      onClose: (selectedDates, dateStr) => {
        if (this.el.dataset.close) {
          this.pushEventTo(this.el, this.el.dataset.close, { date: dateStr })
        }
      }
    })

    // Add click handler to open calendar and force reposition
    this.el.addEventListener('click', () => {
      cal.open()
      cal._positionCalendar(this.el)  // Force reposition after opening
    })

    if (this.el.dataset.focus === 'true') {
      cal.open()
    }

    this.cal = cal
  },

  destroyed() {
    if (this.cal) {
      this.cal.destroy()
    }
  }
}
